export const APP_UPDATE_URL = 'https://fxscms.oss-cn-beijing.aliyuncs.com/fxdzc/scm8pad-1-normal.apk'
// export const APP_UPDATE_URL = 'https://fxscms.oss-cn-beijing.aliyuncs.com/fxdzc/scm8pad-1-test.apk'
